import { IApp } from '@todesktop/shared';

export const getPendingWindowsEVRequestName = (
  app: IApp | null | undefined,
) => {
  const name = app?.meta?.windowsEVOnboarding?.tempHSMCertName;
  if (!name) return '';
  const signingConfig = app?.customWindowsCodeSign;
  if (
    (signingConfig &&
      'hsmCertName' in signingConfig &&
      signingConfig.hsmCertName === name) ||
    Object.values(app?.windowsHsmCertNames || {}).includes(name)
  )
    return '';
  return name;
};

// Shared with the Functions that write certificate references.
export {
  getWindowsEVRequestHistoryEntry,
  getWindowsEVRequestReset,
} from '@todesktop/shared';
